import type { SVGProps } from "react";

export const Name = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.83331 18.3334C3.83331 16.5653 4.53569 14.8696 5.78593 13.6193C7.03618 12.3691 8.73187 11.6667 10.5 11.6667C12.2681 11.6667 13.9638 12.3691 15.214 13.6193C16.4643 14.8696 17.1666 16.5653 17.1666 18.3334H3.83331ZM10.5 10.8334C7.73748 10.8334 5.49998 8.59587 5.49998 5.83337C5.49998 3.07087 7.73748 0.833374 10.5 0.833374C13.2625 0.833374 15.5 3.07087 15.5 5.83337C15.5 8.59587 13.2625 10.8334 10.5 10.8334Z" />
  </svg>
);
